import React from 'react';
import { useMsal } from '@azure/msal-react';

const SignInButton = () => {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginRedirect({
            scopes: ["User.Read", "Group.Read.All"], // Erforderliche Berechtigungen
            prompt: 'select_account' // Allows users to select account or use SSO
        }).catch(e => {
            console.error(e);
        });
    };

    return (
        <button onClick={handleLogin}>
            Mit Microsoft anmelden
        </button>
    );
};

export default SignInButton;
